import { Button } from "@aircall/ds";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";
import { PercentBadge } from "@/components/PercentBadge/PercentBadge";

function NoEvaluation() {
  return (
    <div className="flex flex-col gap-2">
      <SectionHeader>
        <SectionTitle>Call evaluation</SectionTitle>
      </SectionHeader>
      <div>
        <Button variant="link" size="sm" className="m-0 p-0">
          Start call evaluation
        </Button>
      </div>
    </div>
  );
}

function NoEvaluationDisabled() {
  return (
    <div className="flex flex-col gap-2">
      <SectionHeader>
        <SectionTitle>Call evaluation</SectionTitle>
      </SectionHeader>
      <span className="text-xs font-normal text-muted-foreground">
        No call evaluation yet
      </span>
    </div>
  );
}

function WithEvaluation() {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <SectionHeader>
            <SectionTitle>Call evaluation</SectionTitle>
          </SectionHeader>
          <span className="text-tiny font-normal">Overall score: 8/10</span>
        </div>
        <PercentBadge value={80} borderless />
      </div>
      <span className="text-sm font-normal">
        Great call — clear and well structured.
      </span>
    </div>
  );
}

export function PlaygroundSectionCallEvaluation() {
  return (
    <div className="flex flex-col gap-8">
      <Section data-test="call-evaluation-section">
        <NoEvaluation />
      </Section>

      <Section data-test="call-evaluation-section">
        <NoEvaluationDisabled />
      </Section>

      <Section data-test="call-evaluation-section">
        <WithEvaluation />
      </Section>
    </div>
  );
}
